import { ref } from 'vue'
import { getVersion } from '@/api'

// The bot's username, for links into its chat. It comes with `GET /version`; one request is shared by every caller.
// Stays empty until loaded and after a failure, so a command is then shown as plain text.
// The same answer carries the optional privacy and imprint URLs of the landing page (`useLegalLinks`).
const botUsername = ref('')
const privacyUrl = ref('')
const imprintUrl = ref('')
let loading: Promise<void> | null = null

export function loadBotUsername(): Promise<void> {
  if (!loading) {
    loading = getVersion().then(
      (info) => {
        botUsername.value = info.bot_username ?? ''
        privacyUrl.value = info.privacy_url ?? ''
        imprintUrl.value = info.imprint_url ?? ''
      },
      () => {
        loading = null
      },
    )
  }
  return loading
}

export function useBotUsername() {
  void loadBotUsername()
  return botUsername
}

// The privacy policy and imprint URLs the server is configured with, empty while unknown or not set.
export function useLegalLinks() {
  void loadBotUsername()
  return { privacyUrl, imprintUrl }
}

export function resetBotUsername(): void {
  botUsername.value = ''
  privacyUrl.value = ''
  imprintUrl.value = ''
  loading = null
}
